let ctx;
const KEY = "snaplist.beepVolume";
export const beepVolume = () => { const v = Number(localStorage.getItem(KEY)); return Number.isFinite(v) && localStorage.getItem(KEY) !== null ? v : 50; };
export const setBeepVolume = (v) => localStorage.setItem(KEY, String(Math.max(0, Math.min(100, Math.round(v)))));

// Scan beep; loudness follows the saved volume (0 = silent).
export function beep(ok = true) {
  const vol = beepVolume();
  if (!vol) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = ok ? 1200 : 300;
    g.gain.setValueAtTime(0.3 * (vol / 100) ** 1.5 + 0.001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.12);
  } catch { /* audio unavailable */ }
}
